import { createAction, props } from '@ngrx/store';
import { CountryModel } from 'src/app/domain/models/country.model';

export const getAllCountry = createAction('[Component X] get all countrys');

export const getAllContrySuccess = createAction(
    '[Component X] get all contry success',
    props<{ contrys: CountryModel[] }>(),
);
